import { render, staticRenderFns } from "./CongratulationEffect.vue?vue&type=template&id=4f682106&"
import script from "./CongratulationEffect.vue?vue&type=script&lang=js&"
export * from "./CongratulationEffect.vue?vue&type=script&lang=js&"
import style0 from "./CongratulationEffect.vue?vue&type=style&index=0&id=4f682106&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports